export default function MarketDataPanel({ data, isPaused }) {
  const entities = [
    { name: 'People', icon: '👤', key: 'people', stats: [
      { label: 'Particles', value: data.people.particles },
      { label: 'Premiums', value: `$${data.people.premiums.toFixed(0)}` },
      { label: 'Claims', value: data.people.claims }
    ]},
    { name: 'Businesses', icon: '🏢', key: 'businesses', stats: [
      { label: 'Particles', value: data.businesses.particles },
      { label: 'Premiums', value: `$${data.businesses.premiums.toFixed(0)}` },
      { label: 'Claims', value: data.businesses.claims }
    ]},
    { name: 'Agencies', icon: '🏪', key: 'agencies', stats: [
      { label: 'Particles', value: data.agencies.particles },
      { label: 'Commissions', value: `$${data.agencies.commissions.toFixed(0)}` }
    ]},
    { name: 'Carriers', icon: '🏛️', key: 'carriers', stats: [
      { label: 'Particles', value: data.carriers.particles },
      { label: 'Premiums', value: `$${data.carriers.premiums.toFixed(0)}` },
      { label: 'Claims', value: data.carriers.claims },
      { label: 'Profit', value: `${data.carriers.profit.toFixed(0)}%` }
    ]},
    { name: 'Wholesalers', icon: '📦', key: 'wholesalers', stats: [
      { label: 'Particles', value: data.wholesalers.particles },
      { label: 'Commissions', value: `$${data.wholesalers.commissions.toFixed(0)}` }
    ]},
    { name: 'Reinsurance', icon: '🌐', key: 'reinsurance', stats: [
      { label: 'Particles', value: data.reinsurance.particles },
      { label: 'Ceding', value: `$${data.reinsurance.cedingPremiums.toFixed(0)}` },
      { label: 'Recoveries', value: `$${data.reinsurance.recoveries.toFixed(0)}` }
    ]}
  ]

  return (
    <div className="fixed left-5 top-5 bottom-5 w-60 bg-[#1a1a1a] border-2 border-[#333] rounded-xl shadow-[0_5px_20px_rgba(0,0,0,0.5)] flex flex-col z-[100]">
      <div className="p-4 pb-3 border-b border-[#333]">
        <h3 className="m-0 text-[#667eea] text-lg font-medium">Market Data</h3>
        <div className="mt-1 text-xs text-[#666] tracking-[0.5px]">Live ecosystem metrics</div>
      </div>

      <div className="flex-1 overflow-y-auto p-4 custom-scrollbar">
        {entities.map(entity => (
          <div 
            key={entity.key}
            className={`flex gap-3 p-3 mb-2.5 bg-[#222] border-l-[3px] border-[#444] rounded-md transition-all duration-300 ${
              isPaused ? 'cursor-pointer hover:bg-[#333] hover:border-l-[#ffd700]' : ''
            }`}
          >
            <div className="text-2xl leading-none">{entity.icon}</div>
            <div className="flex-1">
              <div className="text-sm text-[#ddd] font-semibold mb-2">{entity.name}</div>
              <div className="flex flex-col gap-1">
                {entity.stats.map(stat => (
                  <div key={stat.label} className="flex justify-between text-xs">
                    <span className="text-[#888]">{stat.label}</span>
                    <span className="text-[#bbb] font-semibold font-mono">{stat.value}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="p-3 border-t border-[#333]">
        <div className="text-[0.7rem] text-[#888] leading-[1.4]">
          <strong className="text-[#aaa]">Note:</strong> Click circles when paused to view details
        </div>
      </div>
    </div>
  )
}

